// extracted by mini-css-extract-plugin
export var caseStudyHeader = "case-study-header-module--case-study-header--39zxV";
export var title = "case-study-header-module--title--1AlkS";
export var subtitle = "case-study-header-module--subtitle--3yRQ5";
export var description = "case-study-header-module--description--fStX6";